import type { MessageKey } from '@/lib/i18n/messages/en'

export const GUIDE_SLUGS = ['create-restaurant', 'setup-restaurant', 'setup-branch', 'branch-operation'] as const
export type GuideSlug = (typeof GUIDE_SLUGS)[number]

export interface Guide {
  slug: GuideSlug
  label: MessageKey
  /** `YYYY-MM-DD` the text was last checked against the app; bump it with every edit. */
  updated: string
}

/** The four tabs of the user guide, in lifecycle order (2026-10-02). */
export const GUIDES: readonly Guide[] = [
  { slug: 'create-restaurant', label: 'guide.createRestaurant', updated: '2026-10-02' },
  { slug: 'setup-restaurant', label: 'guide.setupRestaurant', updated: '2026-10-02' },
  { slug: 'setup-branch', label: 'guide.setupBranch', updated: '2026-10-02' },
  { slug: 'branch-operation', label: 'guide.branchOperation', updated: '2026-10-02' },
]

export function isGuideSlug(value: string): value is GuideSlug {
  return (GUIDE_SLUGS as readonly string[]).includes(value)
}
